import { memo } from 'react'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { AiOutlineClose } from 'react-icons/ai'
import { BulkBatch } from "../pages/Form/EditBatchNo"

const RemoveLotEditor = memo(({ props } : {
  props: EditorProps<BulkBatch>
}) => {
  const { onClose, onRowChange, row } = props

  return row.deleted ? <Modal show={true} onHide={onClose}
    okTheme='success'
    okText='ยืนยัน'
    okAction={() => {
      let updatedRow = { ...row }
      updatedRow.deleted = undefined
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title='เปิด Lot กลับมา'
    maxWidth='max-w-lg'
    >
    <div className='flex items-center gap-3'>
      <div className="space-y-3 ">
        <h6>คุณกำลังจะเปิด Lot กลับมา ดังนี้</h6>
        <h6 className="font-bold text-green-500">Batch No : {row.newBatchNo}</h6>
        <h6>ยืนยันหรือไม่ ?</h6>
      </div>
    </div>
  </Modal> :
  <Modal show={true} onHide={onClose}
    okTheme='danger'
    okText='ยืนยัน'
    okAction={() => {
      let updatedRow = { ...row }
      updatedRow.deleted = true
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title='คำเตือนเนื่องจากมีการลบรายการ Lot ที่ไม่ต้องการ'
    maxWidth='max-w-lg'
    >
    <div className='flex items-center gap-3'>
      <AiOutlineClose size={50} className='text-red-500 basis-1/6 ' />
      <div className="space-y-3 ">
        <h6>คุณกำลังจะลบรายการ Lot ที่ไม่ต้องการ ดังนี้</h6>
        <h6 className="font-bold text-red-500">Batch No : {row.newBatchNo}</h6>
        <h6>ยืนยันลบหรือไม่ ?</h6>
      </div>
    </div>
  </Modal>
})

export default RemoveLotEditor